import { IComponentOptions } from 'angular';
import { LeadStepCtrl } from './lead-step.controller';

export const LeadStepComponent: IComponentOptions = {
  template: require('./lead-step.html'),
  bindings: {
    currentSupport: '<',
    resolvedSchoolUsers: '<',
    nextStep: '&',
    prevStep: '&',
  },
  controller: LeadStepCtrl,
};

angular.module('nv.SupportsModule').component('leadStep', LeadStepComponent);
